import { defaults } from 'sanitize-html';

import { SANITIZE_PROFILE_DEFAULT } from 'app/utils/htmlSanitizer/profiles/default';
import { SanitizationOption } from 'app/utils/htmlSanitizer/types';

export const SANITIZE_PROFILE_SIDEKICK: SanitizationOption = {
  ...SANITIZE_PROFILE_DEFAULT,
  allowedTags: [...defaults.allowedTags, 'del', 'input'],
  allowedAttributes: {
    ...SANITIZE_PROFILE_DEFAULT.allowedAttributes,
    input: [{ name: 'type', values: ['checkbox'] }, 'checked', 'disabled'],
    th: ['align'],
    td: ['align'],
  },
  exclusiveFilter: (frame) =>
    frame.tag === 'input' && frame.attribs.type !== 'checkbox',
};
